export function scheduleSelectors(state) {
  return state.schedule;
}